'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cubify = require('./cubify');

var _cubify2 = _interopRequireDefault(_cubify);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reversePoints = function reversePoints(shape) {
  var c = void 0;

  return shape.reverse().map(function (_ref) {
    var x = _ref.x;
    var y = _ref.y;
    var curve = _ref.curve;

    var point = { x: x, y: y };

    if (c) {
      var _c = c;
      var x2 = _c.x1;
      var y2 = _c.y1;
      var x1 = _c.x2;
      var y1 = _c.y2;

      point.curve = { type: 'cubic', x1: x1, y1: y1, x2: x2, y2: y2 };
    }

    c = curve ? curve : null;

    return point;
  });
};

var reverse = function reverse(s) {
  return (0, _helpers.applyFuncToShapes)(reversePoints, (0, _cubify2.default)(s));
};

exports.default = reverse;